<script>
export default {
   name:"p-card",
   data() {
      return {
      }
   },
   props:['featured'],
   methods: {
   },
   created: function(){
    }
}
</script>
<template>
   
   <div class="p-card" :class="{featured: typeof featured != 'undefined'}">
      <slot></slot>
   </div>
</template>
<style lang="scss"></style>


// WEBPACK FOOTER //
// src/js/components/p-card.vue